import React from 'react';

const PLACEHOLDER_PATTERN = /(\[.*?\|.*?\])/g;

const ComposableMarkup = props => {
  const message = `${props.children}`;
  const parts = message.split(PLACEHOLDER_PATTERN);

  const elementNodes = [];

  parts.forEach(part => {
    const toReplace = PLACEHOLDER_PATTERN.test(part);
    if (toReplace) {
      /* eslint-disable no-useless-escape */
      const [text, key] = part.replace(/[\[\]]/g, '').split(/\|/g);
      const { type, ...component } = props.components[key];
      elementNodes.push(type({ ...component.props, children: text }));
    } else {
      elementNodes.push(part);
    }
  });

  return React.createElement(props.container, props, elementNodes);
};

export default ComposableMarkup;
